import { render, staticRenderFns } from "./TransactionOverviewView.vue?vue&type=template&id=ccdd27b2&scoped=true&"
import script from "./TransactionOverviewView.vue?vue&type=script&lang=ts&"
export * from "./TransactionOverviewView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionOverviewView.vue?vue&type=style&index=0&id=ccdd27b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdd27b2",
  null
  
)

export default component.exports